import script from "./GoogleAuthenticatorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoogleAuthenticatorView.vue?vue&type=script&setup=true&lang=ts"

import "./GoogleAuthenticatorView.vue?vue&type=style&index=0&id=7eca0a5f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eca0a5f"]])

export default __exports__